// Styles
import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";

// Vuetify
import { createVuetify } from "vuetify";

export default createVuetify();
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
